import * as React from 'react'

import * as styles from './ModalError.css'

interface ModalErrorProps {
  message: string | null
}

const ModalError: React.FunctionComponent<ModalErrorProps> = ({ message }) => {
  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        <div className={styles.title}>
          <p className={styles.titleText}>通信エラー</p>
        </div>
        <div className={styles.body}>
          <p className={styles.bodyText}>
            {message ||
              '通信エラーが発生しました。お手数をおかけしますが、ブラウザ画面の再読み込みをお願いいたします。'}
          </p>
        </div>
      </div>
    </div>
  )
}

export default ModalError
